// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    RedoDot,
    RefreshCcw,
    RefreshCcwDot,
    RefreshCw,
    RefreshCwOff,
    Refrigerator,
    Regex,
    RemoveFormatting,
    Repeat,
    Repeat1,
    Repeat2,
    RepeatOff,
    Replace,
    ReplaceAll,
    Reply,
    ReplyAll,
    Rewind,
    Ribbon,
    Road,
    RobotArm,
    RobotVacuum,
    Rocket,
    RockingChair,
    RollerCoaster,
    Rose,
    Rotate3d,
    RotateCcw,
    RotateCcwClock,
    RotateCcwKey,
    RotateCcwSquare,
    RotateCw,
    RotateCwFadingClock,
    RotateCwSquare,
    Route,
    RouteOff,
    Router,
    Rows2,
    Rows3,
    Rows4,
    Rss,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "redo-dot" through "rss", inclusive. */
const shard: Record<string, LucideIcon> = {
    "redo-dot": RedoDot,
    "refresh-ccw": RefreshCcw,
    "refresh-ccw-dot": RefreshCcwDot,
    "refresh-cw": RefreshCw,
    "refresh-cw-off": RefreshCwOff,
    refrigerator: Refrigerator,
    regex: Regex,
    "remove-formatting": RemoveFormatting,
    repeat: Repeat,
    "repeat-1": Repeat1,
    "repeat-2": Repeat2,
    "repeat-off": RepeatOff,
    replace: Replace,
    "replace-all": ReplaceAll,
    reply: Reply,
    "reply-all": ReplyAll,
    rewind: Rewind,
    ribbon: Ribbon,
    road: Road,
    "robot-arm": RobotArm,
    "robot-vacuum": RobotVacuum,
    rocket: Rocket,
    "rocking-chair": RockingChair,
    "roller-coaster": RollerCoaster,
    rose: Rose,
    "rotate-3d": Rotate3d,
    "rotate-ccw": RotateCcw,
    "rotate-ccw-clock": RotateCcwClock,
    "rotate-ccw-key": RotateCcwKey,
    "rotate-ccw-square": RotateCcwSquare,
    "rotate-cw": RotateCw,
    "rotate-cw-fading-clock": RotateCwFadingClock,
    "rotate-cw-square": RotateCwSquare,
    route: Route,
    "route-off": RouteOff,
    router: Router,
    "rows-2": Rows2,
    "rows-3": Rows3,
    "rows-4": Rows4,
    rss: Rss,
};

export default shard;
